import { useCallback, useState } from 'react';
import _ from 'lodash';

import { useSnackbar } from '@/modules/core';
import { SnackbarState } from '@/modules/core/core.types';

import { LettersOfMedicalNecessity } from '../LettersOfMedicalNecessity.types';
import { useDeleteLettersOfMedicalNecessityQuery } from '../queries';
interface Params {
  onSuccess: () => void;
  onError?: () => void;
  item?: LettersOfMedicalNecessity;
}
const CANNOT_DELETE_MESSAGE = 'can not be deleted because it has claims';
const useDeleteLMN = ({ onSuccess, item, onError }: Params) => {
  const { handleDelete } = useDeleteLettersOfMedicalNecessityQuery();
  const [loading, setLoading] = useState(false);
  const { handleAddPermanentSnackbar } = useSnackbar();

  const handleConfirm = useCallback(async () => {
    setLoading(true);
    try {
      await handleDelete(item?.id || '');
      onSuccess();
      handleAddPermanentSnackbar({
        text: `${item?.name} has been deleted.`,
        state: SnackbarState.negative,
        closeIcon: true,
      });
    } catch (e) {
      const errorMessage = _.get(e, 'response.data.elevate_error_message', '') as string;
      const isCannotDelete = errorMessage?.includes(CANNOT_DELETE_MESSAGE);

      if (isCannotDelete && onError) {
        onError();
      }
    } finally {
      setLoading(false);
    }
  }, [handleDelete, item?.id, item?.name, onSuccess, handleAddPermanentSnackbar, onError]);
  return {
    loading,
    handleConfirm,
  };
};

export default useDeleteLMN;
